export const getLanguageFromURL = () => {
  const pathParts = window.location.pathname.split("/");
  const urlLang = pathParts[1]; // Assumes the language is the first segment of the path

  // Add language detection logic if necessary, e.g., fallback to default language if not supported
  return urlLang;
};
